import { render, staticRenderFns } from "./TextAlignmentProperty.vue?vue&type=template&id=0e57c3ec&"
import script from "./TextAlignmentProperty.vue?vue&type=script&lang=js&"
export * from "./TextAlignmentProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports